/* Glowinex Highlights V2: copy-only variant personalization.
   The native Shopify product form remains the sole source of variant state. */
(function(){
'use strict';
if(window.GlowinexHighlightsDynamicV2 && window.GlowinexHighlightsDynamicV2.bound){
  window.GlowinexHighlightsDynamicV2.boot();return;
}
var api={bound:true};
window.GlowinexHighlightsDynamicV2=api;
var norm=function(s){return String(s==null?'':s).trim().toLowerCase();};
function currentOption(cfg,v,name){
  var i=cfg.optionNames.findIndex(function(x){return norm(x)===norm(name);});
  return i<0?'':String(v.options[i]||'').trim();
}
function setCard(panel,index,label,title,description){
  var c=panel.__glxHL.cards[index];if(!c)return;
  if(label)c.label.textContent=label;
  if(title)c.title.textContent=title;
  if(description)c.description.textContent=description;
}
function personalized(panel,variant){
 var cfg=panel.__glxHL.config;
 var opt=function(name){return currentOption(cfg,variant,name);};
 var a,b,c,m;
 switch(cfg.handle){
 case 'glowinex-aura-orbit-floor-lamp':
  a=opt('Ring Stlye');
  if(a==='Single Ring')setCard(panel,2,'YOUR RING STYLE','Single Ring design','Give a bedroom or living-room corner a restrained sculptural accent with the clean single-ring base.');
  if(a==='Double Ring')setCard(panel,2,'YOUR RING STYLE','Double Ring design','Make a stronger sculptural statement in your chosen corner with the layered double-ring base.');
  break;
 case 'glowinex-edge-hexagon-light-panels':
  a=opt('Pack Size');b=opt('Connectivity');
  if(a)setCard(panel,1,'YOUR KIT SIZE',a,'Plan a compact or larger wall accent around your desk or gaming area with this '+a.toLowerCase()+' kit.');
  if(b)setCard(panel,2,'YOUR CONNECTION',norm(b)==='wi-fi'?'Wi-Fi version':'Bluetooth version','Use the supported '+b+' controls on the selected variant; the alternative connection is a different version.');
  break;
 case 'glowinex-edge-triangle-light-panels':
  a=opt('Pack Size');b=opt('Connectivity');
  if(a)setCard(panel,1,'YOUR KIT SIZE',a,'Use this '+a.toLowerCase()+' set to create a triangular accent on a bedroom, desk or gaming-room wall.');
  if(b)setCard(panel,2,'YOUR CONNECTION',b+' version','Choose compatible '+b+' controls for the selected panel set; supported functions depend on the variant.');
  break;
 case 'glowinex-edge-link-light-bars':
  a=opt('Kit Size');b=opt('Color');c=opt('Control Type');
  if(a)setCard(panel,1,'YOUR BAR SET',a,'Connect the selected '+a.toLowerCase()+' into a compatible geometric design suited to your wall.');
  if(c)setCard(panel,2,'YOUR CONNECTION',c+' control','Use the selected '+c+' configuration for compatible control of your wall light bars.');
  if(b)setCard(panel,3,'YOUR FINISH',b+' housing','Match the '+b.toLowerCase()+' bars to the look of your desk, bedroom or entertainment wall.');
  break;
 case 'glowinex-flow-curve-neon-strip':
  a=opt('Length');b=opt('Control Type');
  if(a)setCard(panel,2,'YOUR STRIP LENGTH',a+' flexible neon','Trace a shelf, desk edge or decorative outline using the selected '+a+' strip.');
  if(b){
   m=norm(b);
   setCard(panel,3,'YOUR CONTROL KIT',b,m.includes('bluetooth')?'Use the Bluetooth remote variant for its supported compatible light controls.':m.includes('music')?'Use this '+b+' version to add supported sound-reactive modes to your accent lighting.':'Use the selected IR remote to adjust supported colours and light effects.');
  }
  break;
 case 'glowinex-luma-adapt-smart-bulb':
  a=opt('Bulb Base');b=opt('Smart Home');
  if(a)setCard(panel,1,'YOUR BULB BASE',a+' fitting','Bring smart light to an existing compatible '+a+' fixture without replacing the whole lamp.');
  if(b){
   m=norm(b).includes('matter');
   setCard(panel,2,'YOUR SMART SYSTEM',m?'Matter over Wi-Fi':'Smart Hub (Zigbee)',m?'Connect this Matter-over-Wi-Fi version to a compatible Matter controller and ecosystem.':'Use this hub-based Zigbee version with a compatible gateway or bridge; Matter over Wi-Fi is a different variant.');
  }
  break;
 case 'glowinex-halo-bloom-table-lamp':
  a=opt('Smart Home');
  if(a){
   m=norm(a)==='matter';
   setCard(panel,2,'YOUR SMART SYSTEM',m?'Matter variant':'Wi-Fi Smart variant',m?'Use this variant with a compatible Matter controller to fit your existing smart-home setup.':'Control the Wi-Fi Smart variant with its supported app and pairing setup; Matter is a separate version.');
  }
  break;
 case 'glowinex-zenith-pulse-ceiling-light':
  a=opt('Diameter');
  if(a)setCard(panel,3,'YOUR CEILING SIZE',a+' design','Choose the '+a+' round ceiling fixture to suit the proportions and mounting area of your room.');
  break;
 case 'glowinex-luma-connect-smart-bulb':
  a=opt('Base Type');b=opt('Pack Size');
  if(a&&b)setCard(panel,3,'YOUR BULB SET',a+' · '+b,'Match the '+a+' socket and use this '+b.toLowerCase()+' pack for '+(b==='2 Bulbs'?'two compatible fixtures.':'one compatible fixture.'));
  break;
 case 'glowinex-halo-rhythm-light-bar':
  a=opt('Pack Size');
  if(a)setCard(panel,3,'YOUR LIGHT-BAR SET',a,a==='2 Lights'?'Arrange two matching bars around a desk or monitor for a more balanced ambient accent.':'Use one bar for a compact colour accent on a desk, shelf or beside a monitor.');
  break;
 case 'glowinex-luma-tone-smart-bulb':
  a=opt('Lighting Type');
  if(a){
   m=norm(a).includes('tunable');
   setCard(panel,0,m?'YOUR WHITE-LIGHT VERSION':'YOUR COLOUR-LIGHT VERSION',m?'Tunable White · 7 W':'RGB colour · 4.9 W',m?'Adjust white light for relaxed evenings or everyday tasks; this version is not the RGB bulb.':'Add colourful accents to a bedroom or gaming setup; tunable white is a separate bulb model.');
  }
  break;
 case 'glowinex-sync-signal-tv-backlight':
  a=opt('Screen Size');
  if(a)setCard(panel,2,'YOUR SCREEN KIT',a,'Give your '+a+' screen a size-matched backlight setup for more immersive viewing.');
  break;
 case 'glowinex-sync-stage-monitor-lighting-system':
  a=opt('Kit Type');
  if(a){
   m=norm(a).includes('monitor kit');
   setCard(panel,0,m?'SCREEN-REACTIVE SETUP':'DESKTOP AMBIENCE',m?'Screen-synchronised monitor light':'Standalone RGB light bars',m?'Extend supported screen colours beyond a compatible '+a.replace(' Monitor Kit','')+' monitor for a more immersive gaming desk.':'Add two RGB light bars to your desktop; the standalone set is not represented as a screen-synchronised monitor kit.');
   setCard(panel,2,'YOUR SELECTED KIT',a,m?'Choose the '+a+' for a size-matched monitor installation.':'Use the standalone two-bar option for flexible lighting around a desk or entertainment space.');
  }
  break;
 case 'glowinex-sync-frame-monitor-backlight':
  a=opt('Screen Size');b=opt('Coverage');c=opt('Controller Housing');
  if(a)setCard(panel,2,'YOUR MONITOR SIZE',a+' configuration','Fit the lighting around a compatible '+a+' monitor with the selected coverage layout.');
  if(b)setCard(panel,1,'YOUR COVERAGE',b==='4-Side'?'Four-sided frame':'Three-sided frame',b==='4-Side'?'Outline all four sides for a fuller ambient halo around the display.':'Add a three-sided halo around the monitor for a lighter frame effect.');
  if(c)setCard(panel,3,'YOUR CONTROLLER',c,c==='With Housing'?'The selected controller includes its housing for the supported indoor installation.':'This variant has a bare-board controller without the additional protective housing.');
  break;
 case 'glowinex-aura-rgbic-floor-lamp':
  a=opt('Size');b=opt('Connectivity');
  if(a){
   m=norm(a).includes('cct');
   setCard(panel,1,m?'COLOUR + WHITE LIGHT':'RGBIC LIGHTING',m?'RGBIC + CCT white':'RGBIC colour effects',m?'Use layered colour and adjustable white light for both ambient scenes and daily moments.':'Create layered RGBIC colour scenes with the 10 W lamp. Choose an RGBIC + CCT configuration for adjustable white light.');
   setCard(panel,3,'YOUR LAMP SIZE',a,'Place your chosen floor-lamp configuration beside a sofa, desk or entertainment area to shape the room\'s mood.');
  }
  if(b)setCard(panel,2,'YOUR CONNECTION',b+' controls','Manage supported modes using the compatible '+b+' app and remote version you selected.');
  break;
 case 'glowinex-flow-spectrum-neon-strip':
  a=opt('Size');b=opt('Connectivity');
  if(a)setCard(panel,2,'YOUR STRIP LENGTH',a+' · '+(a==='10 m'?'24 V':'12 V'),'Plan your desk or wall outline with the selected '+a+' strip and its listed '+(a==='10 m'?'24 V':'12 V')+' power specification.');
  if(b)setCard(panel,3,'YOUR CONNECTION',b+' controls','Set supported colours and effects through your selected '+b+' control option to suit the moment.');
  break;
 case 'glowinex-aura-core-floor-lamp':
  a=opt('Size');b=opt('Pack Size');
  if(a)setCard(panel,3,'YOUR FLOOR-LAMP SET',a+(b?' · '+b:''),b==='2 Lamps'?'Create a balanced ambient look with two lamps at your chosen '+a+' height.':'Add a distinctive ambient accent beside your sofa, desk or favourite corner with your chosen '+a+' lamp.');
  break;
 case 'glowinex-sync-vision-tv-backlight':
  a=opt('Length');
  if(a)setCard(panel,2,'YOUR BACKLIGHT KIT',a,'Frame a compatible TV with your selected '+a+' backlight length for a more enveloping glow.');
  break;
 default:break;
 }
}
function panel(){
 var all=Array.from(document.querySelectorAll('[data-glx-featured-panel]'));
 return all.find(function(p){return !p.hidden&&p.closest('#MainContent');})||all.find(function(p){return !p.hidden;})||null;
}
function init(p){
 if(p.__glxHL)return p.__glxHL;
 var script=p.querySelector('[data-glx-hl-config]'),cfg;
 if(!script)return null;
 try{cfg=JSON.parse(script.textContent);}catch(_){return null;}
 if(!cfg||!Array.isArray(cfg.variants)||!Array.isArray(cfg.optionNames))return null;
 var cards=Array.from(p.querySelectorAll('.glx-featured-v2__card')).map(function(el){
  return {label:el.querySelector('.glx-featured-v2__label'),title:el.querySelector('.glx-featured-v2__card-title'),description:el.querySelector('.glx-featured-v2__description')};
 });
 if(cards.length!==4||cards.some(function(c){return !c.label||!c.title||!c.description;}))return null;
 var original=cards.map(function(c){return {label:c.label.textContent,title:c.title.textContent,description:c.description.textContent};});
 var byId=new Map();cfg.variants.forEach(function(v){byId.set(String(v.id),v);});
 p.__glxHL={config:cfg,cards:cards,original:original,byId:byId};
 return p.__glxHL;
}
function selectedFromCurrentPicker(state){
 var picker=document.querySelector('#MainContent product-info variant-selects');
 if(!picker)return undefined;
 var groups=Array.from(picker.querySelectorAll('.product-form__input'));
 var choices=groups.map(function(group){
  var field=group.querySelector('input[type="radio"]:checked,select');
  return field?String(field.value||'').trim():null;
 });
 if(!choices.length||choices.some(function(choice){return choice===null;}))return undefined;
 return state.config.variants.find(function(variant){
  return Array.isArray(variant.options)&&
   variant.options.length===choices.length&&
   variant.options.every(function(option,i){return String(option)===choices[i];});
 })||null;
}
function selectedVariant(state){
 var fromPicker=selectedFromCurrentPicker(state);
 if(fromPicker!==undefined)return fromPicker;
 var input=document.querySelector('#MainContent product-info product-form form input[name="id"]')||
  document.querySelector('#MainContent product-info form[action*="/cart/add"] input[name="id"]');
 if(input){if(!input.value)return null;return state.byId.get(String(input.value))||null;}
 var json=document.querySelector('#MainContent product-info variant-selects [data-selected-variant]');
 if(json){try{var v=JSON.parse(json.textContent);return v?state.byId.get(String(v.id))||null:null;}catch(_){}}
 var id=new URL(window.location.href).searchParams.get('variant');
 if(id&&state.byId.has(id))return state.byId.get(id);
 return state.byId.get(String(state.config.initialVariantId))||state.config.variants[0]||null;
}
function render(known){
 var p=panel();if(!p)return false;
 var state=init(p);if(!state)return false;
 var variant=known&&state.byId.has(String(known.id))?state.byId.get(String(known.id)):selectedVariant(state);
 state.cards.forEach(function(c,i){c.label.textContent=state.original[i].label;c.title.textContent=state.original[i].title;c.description.textContent=state.original[i].description;});
 if(variant&&!state.config.customHighlights)personalized(p,variant);
 var box=p.querySelector('[data-glx-highlight-selection]');
 var field=p.querySelector('[data-glx-selected-label]');
 if(box&&field){
  box.hidden=false;
  box.classList.toggle('glx-featured-v2__selection--needs-choice',!variant);
  field.textContent=variant?(variant.options||[]).join(' · '):'Choose a valid option combination to see the exact configuration.';
 }
 return true;
}
var bootToken=0;
function boot(){
 var token=++bootToken,tries=0;
 function attempt(){
  if(token!==bootToken)return;
  if(render()||tries++>=12)return;
  window.setTimeout(attempt,150);
 }
 attempt();
}
api.boot=boot;api.render=render;
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.variantChange){
 subscribe(PUB_SUB_EVENTS.variantChange,function(event){
  var p=panel(),state=p&&init(p);
  if(!state)return;
  var variant=event&&event.data&&event.data.variant;
  if(variant&&state.byId.has(String(variant.id)))render(variant);
  else if(variant===null)window.requestAnimationFrame(function(){render();});
 });
}
var refreshPending=false;
function scheduleRender(){
 if(refreshPending)return;
 refreshPending=true;
 requestAnimationFrame(function(){refreshPending=false;render();});
}
document.addEventListener('change',function(event){
 var el=event.target;
 if(!el?.closest?.('#MainContent product-info'))return;
 // Native radio/select changes are the source of selection.
 // The hidden variant ID only changes after Shopify's async section fetch.
 if(el.closest('variant-selects')||el.matches?.('input[name="id"]'))scheduleRender();
},true);
document.addEventListener('product-info:loaded',boot);
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.optionValueSelectionChange){
 subscribe(PUB_SUB_EVENTS.optionValueSelectionChange,scheduleRender);
}
document.addEventListener('shopify:section:load',boot);
document.addEventListener('shopify:section:select',boot);
window.addEventListener('pageshow',boot);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
else boot();
})();